import { type ServiceMethod } from '@/application/interfaces/service';

import {
  type BannerContext,
  type BaseBody,
  type BaseParams,
  type Size,
  type BannerPlacementKey,
} from '../model';
import { createBaseBody } from '../utils';

import adapter from './adapter';
import { type BannerAds } from './model';

export type Params = BaseParams & {
  context: BannerContext;
};

export type Body = BaseBody & {
  placements: Record<
    BannerPlacementKey,
    {
      quantity: number;
      types: ['banner'];
      size: Size;
    }
  >;
};

export type ExternalResponse = Record<BannerPlacementKey, BannerAds[]>;

export type Response = {
  data: BannerAds[];
};

const baseUrl = process.env.NEXT_PUBLIC_RETAIL_MEDIA_BASE_URL;
const publisherId = process.env.NEXT_PUBLIC_RETAIL_MEDIA_PUBLISHER_ID;

const getBannersAds: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { context, sessionId, userId, device } = data;

    const { body: response } = await httpClient.post<ExternalResponse, Body>(
      `/v1/rma/${publisherId}`,
      {
        ...options,
        body: {
          ...createBaseBody({ context, sessionId, userId, device }),
          placements: {
            [`${device}_${context.name}_${context.position}_banner` satisfies BannerPlacementKey]:
              {
                quantity: 1,
                size: context.size,
                types: ['banner'],
              },
          },
        },
        baseUrl,
      }
    );

    return adapter({ context, device, externalResponse: response });
  };

export default getBannersAds;
